<template>
  <div class="card-content">
    <div class="card-content-inner">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {}
</script>